module.exports = __webpack_public_path__ + "img/logo-bandcamp.a72cb036.svg";